import React from 'react';
import { Dropdown, Badge } from 'react-bootstrap';
import { FaUserTie, FaUser, FaExchangeAlt } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/RoleSwitcher.css';

/**
 * RoleSwitcher - Permite al admin cambiar entre vista Admin y vista Empleado
 * Solo visible para usuarios con permisos de administrador
 */
const RoleSwitcher = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isAdminView = location.pathname.startsWith('/administrador');
  const currentMode = isAdminView ? 'Administrador' : 'Empleado';
  const currentIcon = isAdminView ? <FaUserTie /> : <FaUser />;

  const handleSwitch = (mode) => {
    if (mode === 'admin' && !isAdminView) {
      navigate('/administrador');
    } else if (mode === 'employee' && isAdminView) {
      navigate('/home');
    }
  };

  return (
    <Dropdown align="end" className="role-switcher">
      <Dropdown.Toggle 
        variant="outline-light" 
        id="role-switcher-dropdown"
        className="role-switcher-toggle d-flex align-items-center gap-2"
      >
        {currentIcon}
        <span className="d-none d-md-inline">{currentMode}</span>
        <Badge bg={isAdminView ? 'danger' : 'success'} className="ms-2">
          {isAdminView ? 'Admin' : 'User'}
        </Badge>
      </Dropdown.Toggle>

      <Dropdown.Menu className="role-switcher-menu">
        <Dropdown.Header>
          <FaExchangeAlt className="me-2" />
          Cambiar Vista
        </Dropdown.Header>
        
        <Dropdown.Divider />
        
        <Dropdown.Item 
          onClick={() => handleSwitch('admin')}
          active={isAdminView}
          className="d-flex align-items-center gap-2"
        >
          <FaUserTie className="text-danger" />
          <div>
            <div className="fw-bold">Panel Administrador</div>
            <small className="text-muted">Gestión completa del sistema</small>
          </div>
        </Dropdown.Item>
        
        <Dropdown.Item 
          onClick={() => handleSwitch('employee')}
          active={!isAdminView}
          className="d-flex align-items-center gap-2"
        >
          <FaUser className="text-success" />
          <div>
            <div className="fw-bold">Vista Empleado</div>
            <small className="text-muted">Ver como empleado regular</small>
          </div>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default RoleSwitcher;
